export const voipScreens = {
    WITHOUT_CALL: 'WITHOUT_CALL',
    WITH_CALL: 'WITH_CALL',
    TERMINATED_CALL: 'TERMINATED_CALL',
    CANCELLED_CALL: 'CANCELLED_CALL',
    FAILED_CALL: 'FAILED_CALL',
};
export const endedVoipScreens = [
    voipScreens.FAILED_CALL,
    voipScreens.TERMINATED_CALL,
    voipScreens.CANCELLED_CALL,
];
export const loginStates = {
    PRELOAD: 'preload',
    INITIAL: 'initial',
    CONNECTED: 'connected',
    DISCONNECTED: 'disconnected',
    LOGIN_FAILED: 'login failed',
    LOGIN: 'login',
    LOGOUT: 'logout',
};
export const phoneListeners = {
    LOGIN_STATE_CHANGED: 'loginStateChanged',
    CALL_INCOMING_REINVITE: 'callIncomingReinvite',
    OUTGOING_CALL_PROGRESS: 'outgoingCallProgress',
    CALL_TERMINATED: 'callTerminated',
    CALL_CONFIRMED: 'callConfirmed',
    CALL_SHOW_STREAM: 'callShowStreams',
    INCOMING_CALL: 'incomingCall',
    CALL_HOLD_STATE_CHANGED: 'callHoldStateChanged',
};
export const causes = {
    // Generic error causes.
    CONNECTION_ERROR: 'Connection Error',
    REQUEST_TIMEOUT: 'Request Timeout',
    SIP_FAILURE_CODE: 'SIP Failure Code',
    INTERNAL_ERROR: 'Internal Error',
    // SIP error causes.
    BUSY: 'Busy',
    REJECTED: 'Rejected',
    REDIRECTED: 'Redirected',
    UNAVAILABLE: 'Unavailable',
    NOT_FOUND: 'Not Found',
    ADDRESS_INCOMPLETE: 'Address Incomplete',
    INCOMPATIBLE_SDP: 'Incompatible SDP',
    MISSING_SDP: 'Missing SDP',
    AUTHENTICATION_ERROR: 'Authentication Error',
    // Session error causes.
    BYE: 'Terminated',
    WEBRTC_ERROR: 'WebRTC Error',
    CANCELED: 'Canceled',
    NO_ANSWER: 'No Answer',
    EXPIRES: 'Expires',
    NO_ACK: 'No ACK',
    DIALOG_ERROR: 'Dialog Error',
    USER_DENIED_MEDIA_ACCESS: 'User Denied Media Access',
    BAD_MEDIA_DESCRIPTION: 'Bad Media Description',
    RTP_TIMEOUT: 'RTP Timeout',
};
export const checkAvailableDevicesErrors = {
    NOT_SUPPORTED_WEB_RTC: 'WebRTC is not supported',
    NOT_MICRO: 'Missing a microphone! Please connect one and reload',
    NOT_SPEAKER: 'Missing a speaker! Please connect one and reload',
};
